// sectionCatalog と GetListTabs.panels を結合し、
// Entry Form で使う実表示用のセクション定義へ変換します。

export function canonicalPanelType(type) {
    if (type === null || type === undefined) return "";
    const s = String(type).trim();
    const low = s.toLowerCase();
    if (low === "20" || low === "130" || low === "jutyusu") return "130";
    if (low === "21" || low === "131" || low === "nouhinyotei") return "131";
    return s;
}

function panelLookupKey(panelId, panelType) {
    return `${String(panelId ?? "").trim()}::${canonicalPanelType(panelType)}`;
}

// s_logp に同一typeで別idが存在するため、id/type と type 単体の両方で引けるようにします。
export function buildResolvedSections(sectionCatalog, panels) {
    const safeCatalog = Array.isArray(sectionCatalog) ? sectionCatalog : [];
    const safePanels = Array.isArray(panels) ? panels : [];
    const panelByIdType = new Map();
    const panelByType = new Map();

    safePanels.forEach((panel) => {
        const typeKey = canonicalPanelType(panel?.type);
        const idTypeKey = panelLookupKey(panel?.id, panel?.type);
        if (!panelByIdType.has(idTypeKey)) panelByIdType.set(idTypeKey, panel);
        if (typeKey !== "" && !panelByType.has(typeKey)) panelByType.set(typeKey, panel);
    });

    return safeCatalog.map((section) => {
        const resolvedPanel =
            panelByIdType.get(panelLookupKey(section?.panelId, section?.panelType)) ||
            panelByType.get(canonicalPanelType(section?.panelType)) ||
            null;

        // s_logp 解決済みの情報がある場合だけ見出しや合計typeを上書きし、
        // 未解決時は catalog の fallback 値を維持します。
        if (!resolvedPanel) return { ...section };

        return {
            ...section,
            panelId: String(resolvedPanel.id ?? section.panelId ?? ""),
            panelType: canonicalPanelType(resolvedPanel.type ?? section.panelType ?? ""),
            label: String(resolvedPanel.name ?? section.label ?? ""),
            subLabel: String(resolvedPanel.name2 ?? section.subLabel ?? ""),
            abbr: String(resolvedPanel.abbr ?? section.abbr ?? ""),
            grid: Boolean(resolvedPanel.grid),
            totalType: String(resolvedPanel.totaltype ?? section.totalType ?? ""),
            maxrow: resolvedPanel.maxrow,
            initrow: resolvedPanel.initrow
        };
    });
}
